export default "__VITE_PUBLIC_ASSET__c7a37bd1__"